export enum ButtonVariants {
  PRIMARY = 'primary',
  PRIMARY_BLACK = 'primaryBlack',
  SECONDARY = 'secondary',
  SECONDARY_BLACK = 'secondaryBlack',
  TERTIARY = 'tertiary',
  TERTIARY_BLACK = 'tertiaryBlack',
}
